import { useRef } from 'react';

import useIsomorphicLayoutEffect from './use-isomorphic-layout-effect';

/**
 * Returns a stable callback reference that always invokes the latest version of the provided function.
 * Avoids stale closures without adding the function to dependency arrays.
 */
function useEventCallback<Args extends unknown[], Return>(fn: (...args: Args) => Return): (...args: Args) => Return {
  const fnRef = useRef(fn);

  useIsomorphicLayoutEffect(() => {
    fnRef.current = fn;
  });

  return useRef((...args: Args) => fnRef.current(...args)).current;
}

export default useEventCallback;
